import React, { useState } from 'react'
import ResourceSelectDialog from './ResourceSelectDialog';
import Cooks from '../Cooks/Cooks';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { useAppDispatch } from '../../store/hooks';
import { setCustomSelectOpen } from '../../store/reducers/customSelect';
import { ErrorDialog } from './ErrorDialog';
import { MultiDayChefitService } from '../../services/MultiDayChefitService';
import EventBus from '../../EventBus';
import { EventBusEventsEnum } from '../../enums/EventBusEventsEnum';
import { CustomSnackbarTypes } from './CustomSnackBar';
import { useRefresh, useUnselectAll } from 'react-admin';
import { OneMealService } from '../../services/OneMealService';
import CircularLoader from './CircularLoader';

const multiChefitService = new MultiDayChefitService();
const oneMealService = new OneMealService();

function AssignCookToMultiDayChefitDialog(props : any) {
    const [selectedCook, setSelectedCook] = useState<any>(null);
    const [openError, setOpenError] = useState<boolean>(false);
    const [errorRes, setErrorRes] = useState<any>();
    const [loading, setLoading] = useState<any>(false);
    const dispatch = useAppDispatch();
    const refresh = useRefresh();
    const unselectAll = useUnselectAll("OneMealService");

    const handleClose = async (recordData: any) => {
        setSelectedCook(recordData);
    };
    

    const handleSelectCook = () => {
        dispatch(
          setCustomSelectOpen({
            open: true,
          })
        );
    };

    const handleSubmit = async() => {
        if ( selectedCook && !props?.selectedIds) {
            multiChefitService.assignCookToMultiDayChefit(props.serviceId, selectedCook.id)
            .then((res) => {
              if (res) {
                EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
                  message: "Success",
                  type: CustomSnackbarTypes.SUCCESS,
                });
              }
              setSelectedCook(null);
              props.callback();
              refresh();
            })
            .catch((err) => {
              setErrorRes(err?.response?.data?.data);
              if(err?.response?.data?.data){
                setOpenError(true);
              }
              EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
                message: err?.response?.data?.data ? `` : err?.response?.data?.error,
                type: CustomSnackbarTypes.ERROR,
                duration:  err?.response?.data?.data ? 0 : 3000,
              });
            })
      } 
      else if(selectedCook && props?.selectedIds){
        let successCount = 0;
        let failure = 0;

        const assignCookToServices = async () => {
          const promises = props?.selectedIds.map(async (element: number) => {
            const payload = {
              cookId: Number(selectedCook.id),
              oneMealServiceCookCut: "0",
              allocationNotes: "",
            };

            try {
              setLoading(true);
              const res = await oneMealService.assignCookToOneMealService(
                Number(element),
                payload
              );

              if (res.status === 200) {
                await oneMealService.acceptOneMealService(Number(element), {
                  accepted: true,
                  reason: "Accepted",
                });
                successCount++;
              }
            } catch (error) {
              failure++;
              console.error(error);
            }
          });

          await Promise.all(promises);
          setLoading(false);
          EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
            message: `Cook Allocated Successfully for ${successCount} visits and failed for ${failure} visits`,
            type: CustomSnackbarTypes.SUCCESS,
          });
        }
        await assignCookToServices();
        unselectAll();
        refresh();
      }
      else {
          EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
            message: `Fill the details properly`,
            type: CustomSnackbarTypes.ERROR,
          });
        }
      };
  return (
    <>
      <div>
      {!!props.open && (
        <ResourceSelectDialog
          name={"Cooks"}
          list={Cooks}
          onClose={handleClose}
        />
      )}
      <Dialog open={props.open} scroll={"paper"} maxWidth="xs" fullWidth>
        <DialogTitle>Assign cook</DialogTitle>
        {
          !loading ? <>
          <DialogContent>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
              }}
            >
              <Button
                variant={"contained"}
                color={"primary"}
                onClick={handleSelectCook}
              >
                Select Cook
              </Button>
              {!!selectedCook && (
                <p>Selected cook - {selectedCook?.fname + selectedCook?.lname}</p>
              )}
            </div>
          </DialogContent>
          </>
          : 
          <CircularLoader/>
        }
        <DialogActions style={{ marginTop: "12px" }}>
            <Button
              variant="contained"
              onClick={() => {
                handleSubmit();
              }}
              size={"large"}
            >
              Submit
            </Button>
            <Button
              variant="contained"
              color={"error"}
              onClick={() => {
                  props.callback();
                  setSelectedCook(null);
                // setReason(undefined);
              }}
              size={"large"}
            >
              Cancel
            </Button>
          </DialogActions>
      </Dialog>
      <ErrorDialog
          open={openError}
          onClose={() => {setOpenError(false)}}
          data={errorRes}
      />
    </div>
    </>  
  );
}

export default AssignCookToMultiDayChefitDialog
